export default {
  getIntervalWaterStatistics: 'getIntervalWaterStatistics',
  exportIntervalWaterStatistics: 'exportIntervalWaterStatistics',
  getReservoirIntervalWaterStatistics: 'getReservoirIntervalWaterStatistics',
  getReservoirWaterProcedure: 'getReservoirWaterProcedure',
  exportReservoirIntervalWaterStatistics: 'exportReservoirIntervalWaterStatistics',
  exportReservoirWaterProcedure: 'exportReservoirWaterProcedure'
}
